module.exports = __webpack_public_path__ + "static/media/Lich.6709b9ac.png";